import * as Sentry from "@sentry/react";

const SENSITIVE_QUERY = /^(code|access_token|refresh_token|token|state)$/i;

function dsn() {
  return (import.meta.env.VITE_SENTRY_DSN as string | undefined)?.trim() ?? "";
}

export function initSentry() {
  const value = dsn();
  if (!value) return;
  Sentry.init({
    dsn: value,
    environment:
      (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined)?.trim() ||
      import.meta.env.MODE,
    tracesSampleRate: 0,
    beforeSend(event) {
      const request = event.request;
      if (!request) return event;
      const headers = request.headers ? { ...request.headers } : undefined;
      if (headers) {
        delete headers.Cookie;
        delete headers.cookie;
        delete headers.Authorization;
        delete headers.authorization;
      }
      let query = request.query_string;
      if (typeof query === "string") {
        const params = new URLSearchParams(query);
        for (const key of [...params.keys()]) {
          if (SENSITIVE_QUERY.test(key)) params.set(key, "[filtered]");
        }
        query = params.toString();
      }
      return {
        ...event,
        request: { ...request, cookies: undefined, headers, query_string: query },
      };
    },
  });
}
